import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, X } from 'lucide-react';
export type ToastProps = {
  id: string;
  type: 'success' | 'error';
  message: string;
  onClose: (id: string) => void;
  duration?: number;
};
const Toast = ({
  id,
  type,
  message,
  onClose,
  duration = 5000
}: ToastProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, duration);
    return () => clearTimeout(timer);
  }, [id, onClose, duration]);
  return <div className="flex items-center justify-between p-4 mb-2 rounded-md shadow-md max-w-xs bg-white border border-gray-200" data-id="element-1281" data-mp="19fqw9ugljc7d">
      <div className="flex items-center" data-id="element-1282" data-mp="1j8g8irjz0u3r">
        {type === 'success' ? <CheckCircle className="mr-3 flex-shrink-0 text-green-500" size={18} data-id="element-1283" data-mp="1eh6ihpuiforc" /> : <AlertCircle className="mr-3 flex-shrink-0 text-red-500" size={18} data-id="element-1284" data-mp="qqu35twxqpqq" />}
        <p className="text-sm text-gray-700" data-id="element-1285" data-mp="lt2c124477nl">{message}</p>
      </div>
      <button onClick={() => onClose(id)} className="ml-3 text-gray-400 hover:text-gray-600 flex-shrink-0" aria-label="Close notification" data-id="element-1286" data-mp="lqoi4wl681hm">
        <X size={16} data-id="element-1287" data-mp="1kjfa1usm10dp" />
      </button>
    </div>;
};
export default Toast;